function clearCookies() {
  for (const cookie of document.cookie.split("; ")) {
    const name = cookie.split("=")[0];
    if (!name) continue;

    const parts = window.location.hostname.split(".");
    while (parts.length > 0) {
      document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${parts.join(".")}; path=/; Secure`;
      parts.shift();
    }
  }
}

export default clearCookies;
